import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ComplianceNewsList } from "@/components/ComplianceNewsWidget";
import api from "@/lib/api";

export default function ComplianceNews() {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    localStorage.setItem("eg_news_seen", new Date().toISOString());
    window.dispatchEvent(new Event("eg-news-seen"));
  }, []);
  const refresh = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/employer/compliance-news/refresh");
      if (data.cooldown) {
        toast.info(t("ai.refreshCooldown", { min: Math.max(1, Math.ceil((data.retry_after || 0) / 60)) }));
        setBusy(false);
        return;
      }
      toast.success(t("ai.refreshStarted"));
      let before = 0;
      try { before = (await api.get("/employer/compliance-news?limit=200")).data.news?.length || 0; } catch { /* ignore */ }
      let tries = 0;
      const poll = async () => {
        tries += 1;
        try {
          const now = (await api.get("/employer/compliance-news?limit=200")).data.news?.length || 0;
          setReloadKey((k) => k + 1);
          if (now > before || tries >= 12) { setBusy(false); return; }
        } catch { /* keep polling */ }
        setTimeout(poll, 12000);
      };
      setTimeout(poll, 12000);
    } catch { toast.error("Error"); setBusy(false); }
  };
  return (
    <div data-testid="employer-compliance-news">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-navy sm:text-3xl">{t("ai.newsTitle")}</h1>
          <p className="mt-1 text-sm text-slate-500">{t("ai.newsSubEmp")}</p>
        </div>
        <Button onClick={refresh} disabled={busy} data-testid="emp-news-refresh-btn" className="rounded-full bg-navy text-white hover:bg-navy-muted">
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <RefreshCw className="mr-1 h-4 w-4" />} {busy ? t("ai.refreshing") : t("ai.refresh")}
        </Button>
      </div>
      <ComplianceNewsList limit={50} showFilter reloadKey={reloadKey} />
    </div>
  );
}
